import controllerDataConfigApi from '@/api/config/controllerDataConfig'
import { queryKeys, XLSX_ACEPT, XLSX_FORMAT } from '@/constant/common'
import { useAuthContext } from '@/features/auth/context'
import { NotifyService } from '@/helpers'
import { selectTheme } from '@/store/selectors/ThemeSelector'
import { mode_type } from '@/theme/types/constants'
import { fileContentToBlob } from '@/ultils'
import { Button, CircularProgress, Stack, Typography } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { saveAs } from 'file-saver'
import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { useSelector } from 'react-redux'
import { useSetUpUI } from '../../context'
import SelectExcelFile from './SelectExcelFile'
import classes from './styles.module.scss'

const Mk2DecoderModal = () => {
  const { closeModal } = useSetUpUI()
  const { interfaceId } = useAuthContext()
  const themeMode = useSelector(selectTheme)
  const queryClient = useQueryClient()

  const [fileNames, setFileNames] = useState<any>({})
  const [filePath, setFilePath] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  const onDownload = async () => {
    await controllerDataConfigApi.getMk2Template(Number(interfaceId)).then((res) => {
      saveAs(res.data, 'MK2 Decoder_Template.xlsx')
    })
  }

  useEffect(() => {
    const fileKey = Object.keys(fileNames)[0] // Get the first key in the fileNames object
    if (fileKey) {
      setFilePath(fileNames[fileKey].path) // Update the state with the file path
    } else {
      setFilePath(null) // Reset if no file is selected
    }
  }, [fileNames]) // Run this effect whenever fileNames changes

  const onChangeFile = async (file: File[]) => {
    const newFileNames = file.reduce((acc, file) => {
      acc[file.name] = file
      return acc
    }, {} as { [key: string]: File })

    setFileNames((prevFileNames: any) => ({
      ...prevFileNames,
      ...newFileNames,
    }))
  }

  const buttonStyle = !filePath
    ? {
        opacity: 0.5,
        pointerEvents: 'none',
        userSelect: 'none',
        backgroundColor: '#efefef',
        color: '#8a8a8a',
      }
    : {}

  const handleImport = async () => {
    const fileKey = Object.keys(fileNames)[0] // Adjust this based on your actual structure
    if (!fileKey) return

    setIsLoading(true)
    const data = new FormData()
    data.append('file', fileNames[fileKey])

    await controllerDataConfigApi
      .uploadMk2DecoderFile(Number(interfaceId), data)
      .then(({ data }) => {
        if (data) {
          setIsLoading(false)
          toast.success('Upload file success')
          closeModal()
          queryClient.invalidateQueries([queryKeys.controller, interfaceId])
        } else {
          NotifyService.error('Upload file error')
          setIsLoading(false)
          closeModal()
          if (data.result) {
            saveAs(
              fileContentToBlob(
                data.result.fileContents,
                data.result.contentType,
              ),
              data.result.fileDownloadName,
            )
          }
        }
      })
      .catch((data) => {
        setIsLoading(false)
        closeModal()
        NotifyService.error(data?.message)
      })
  }

  return (
    <Stack className={classes.rootMk2Modal}>
      <Typography className={classes.txtImportMk2}>
        Import MK2 Decoder
      </Typography>
      <Typography mt="6px" className={classes.txtContentImport}>
        Import a list of mk2 decoders by providing the list of decoder number
        via an excel file
      </Typography>

      <Button variant="secondary" sx={{ mt: '20px' }}>
        <SelectExcelFile
          accept={XLSX_ACEPT}
          formats={XLSX_FORMAT}
          onChange={onChangeFile}
          filePath={filePath}
        />
      </Button>

      <Button
        className={classes.btnDownload}
        sx={{
          color: themeMode === mode_type.dark ? '#fff' : '#004744',
        }}
        onClick={onDownload}
      >
        Download excel template
      </Button>

      <Stack direction="row" spacing={1} justifyContent="flex-end" mt="33px">
        <Button variant="secondary" onClick={closeModal}>
          Cancel
        </Button>
        <Button
          startIcon={
            isLoading ? (
              <CircularProgress size={12} sx={{ color: '#fff' }} />
            ) : (
              ''
            )
          }
          variant="primary"
          sx={{ ...buttonStyle }}
          onClick={() => handleImport()}
        >
          Import
        </Button>
      </Stack>
    </Stack>
  )
}

export default Mk2DecoderModal
